import React from 'react';
import {
  registrationEvents,
  useRegistrationControllers,
} from '../../../../services/acceptanceRegistration';
import Btn from '../../../../../../components/btn';

const Register = ({ record, className }) => {
  const { notify } = useRegistrationControllers();

  const handleClick = () => {
    notify(registrationEvents.REGISTRATION_FROM_ROOM, { room: record });
  };

  return (
    <Btn block className={className} onClick={handleClick}>
      Записать
    </Btn>
  );
};

export default Register;
